var _line, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeline05Icuida(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "timeline_05_icuida",
    xmlns: "http://www.w3.org/2000/svg",
    width: 332.937,
    height: 590.945,
    viewBox: "0 0 332.937 590.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_41",
    "data-name": "L\\xEDnea 41",
    x1: 119.5,
    transform: "translate(0 117.802)",
    fill: "none",
    stroke: "#ce6854",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1228",
    "data-name": "Grupo 1228",
    transform: "translate(-872.354 -357.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_869",
    "data-name": "Trazado 869",
    d: "M0,0V408.143",
    transform: "translate(1062 540)",
    fill: "none",
    stroke: "#ce6854",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1227",
    "data-name": "Grupo 1227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1224",
    "data-name": "Grupo 1224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1220",
    "data-name": "Grupo 1220"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_80",
    "data-name": "Rect\\xE1ngulo 80",
    width: 284.937,
    height: 41.829,
    transform: "translate(920.354 587.392)",
    fill: "#ce6854"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Marzo_2019",
    "data-name": "Marzo 2019",
    transform: "translate(1000.404 617.882)",
    fill: "#fff",
    fontSize: 16.576,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Marzo 2019"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1223",
    "data-name": "Grupo 1223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1221",
    "data-name": "Grupo 1221"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_195",
    "data-name": "Elipse 195",
    cx: 97.344,
    cy: 97.344,
    r: 97.344,
    transform: "matrix(0.162, -0.987, 0.987, 0.162, 950.997, 552.273)",
    fill: "#8ccee1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_196",
    "data-name": "Elipse 196",
    cx: 81.163,
    cy: 81.163,
    r: 81.163,
    transform: "translate(948.04 471.98) rotate(-45)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_05.",
    "data-name": 5,
    transform: "translate(982.504 410.105)",
    fill: "#00334e",
    fontSize: 36.479,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "05."))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1222",
    "data-name": "Grupo 1222"
  }, /*#__PURE__*/React.createElement("text", {
    id: "iCuida_Proyecto_ganador",
    "data-name": "iCuida  Proyecto  ganador",
    transform: "translate(1014.947 446.921)",
    fontSize: 25.097,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 23
  }, "iCuida "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 53.117
  }, "Proyecto "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 83.233
  }, "ganador"))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1226",
    "data-name": "Grupo 1226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1225",
    "data-name": "Grupo 1225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_867",
    "data-name": "Trazado 867",
    d: "M1089.5,404.708l10.834-5.7,10.835,5.7-2.069-12.064,8.765-8.545-12.114-1.76-5.417-10.977-5.417,10.977-12.114,1.76,8.766,8.545Zm8.682-17.875,2.152-4.361,2.152,4.361,4.813.7-3.482,3.394.822,4.793-4.3-2.263-4.305,2.263.822-4.793-3.482-3.394Z",
    fill: "#1f2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_868",
    "data-name": "Trazado 868",
    d: "M1070.673,374.459a12.291,12.291,0,0,0,0,24.583h3.487a27.233,27.233,0,0,0,18.8,18.656v10.844h-9.153l-4.916,14.913h-5.6v4.917h54.083v-4.917h-5.6l-4.917-14.913h-9.153V417.686a27.15,27.15,0,0,0,18.644-18.644H1130a12.291,12.291,0,0,0,0-24.583h-2.622v-5.081h5.08v-4.917h-64.244v4.917h4.917v5.081Zm0,19.666a7.375,7.375,0,0,1,0-14.75h2.459v12.292q0,1.244.113,2.458Zm45.932,49.33h-32.536l3.3-10h25.944Zm-13.81-14.913h-4.916V418.6c.81.072,1.629.111,2.458.111s1.648-.039,2.458-.112ZM1130,379.375a7.375,7.375,0,0,1,0,14.75h-2.735c.073-.81.113-1.629.113-2.458V379.375Zm-7.539-10v22.289a22.207,22.207,0,0,1-44.414,0V369.378Z",
    fill: "#1f2121"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline05Icuida);
export default __webpack_public_path__ + "static/media/timeline_05_icuida.5214a6161111dbc8ea7adf9f9095bd07.svg";
export { ForwardRef as ReactComponent };